CollectionView = require 'views/internal/collection-view'
DragSort = require 'views/lib/drag-sort'
GuidedStepListComposerView = require 'views/list/guided-step-list-composer-view'
InlineListComposerView = require 'views/list/inline-list-composer-view'
ListView = require 'views/list/list-view'
assert = require 'lib/assert'
getExperiment = require 'lib/experiments/simple-test'

module.exports = class ListListView extends CollectionView
  viewType: ListView

  initialize: ({ @resetCallback }) ->
    super

    assert @resetCallback?

    @listenTo @collection,
      'reset': @resetCallback
      'change:idBoard': @boardChange

  render: ->
    maxVisibleLists = Math.max(3, Math.ceil(window.innerWidth / 270)) # Hard coded list width

    subviews = @getModels().map (model, index) =>
      @subview @viewType, model, { deferCards: index >= maxVisibleLists }

    if @model.editable()
      if @model.isFirstOwnedBoard() && getExperiment('guidedSteps').get('enabled')
        subviews.push @subview GuidedStepListComposerView, @model
      else
        subviews.push @subview InlineListComposerView, @model

    @ensureSubviews(subviews)
    @resetCallback()

  boardChange: (list, idBoard) ->
    if idBoard == @collection.board.get('id') then return
    @collection.remove(list)
    DragSort.refreshIfInitialized(@$el)

  addModel: ->
    super
    @resetCallback()

  removeSubview: ->
    super
    DragSort.refreshListCardSortable()
    return

  insertSubview: (subview) ->
    super
    if(subview.$el.find('.ui-sortable').length > 0)
      DragSort.refreshIfInitialized(@$el)
    else
      DragSort.refreshListCardSortable()
    return



// WEBPACK FOOTER //
// ./app/scripts/views/list/list-list-view.coffee